import { render, staticRenderFns } from "./afterSaleCopy.vue?vue&type=template&id=2f9b80f0&scoped=true"
import script from "./afterSaleCopy.vue?vue&type=script&lang=js"
export * from "./afterSaleCopy.vue?vue&type=script&lang=js"
import style0 from "./afterSaleCopy.vue?vue&type=style&index=0&id=2f9b80f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9b80f0",
  null
  
)

export default component.exports